import React from 'react';
import './About.css';
import aboutData from '../data/about.json';
import { useContent } from '../contexts/ContentContext';

const About = () => {
  const { getSection } = useContent();
  const data = getSection<typeof aboutData>('about', aboutData);

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="section-header">
          <h2 className="section-title">{data.sectionTitle}</h2>
          <h3 className="section-headline">{data.sectionSubtitle}</h3>
        </div>

        <div className="about-content">
          <div className="about-text">
            <div className="about-description">
              <p dangerouslySetInnerHTML={{ __html: data.description.paragraph1 }}></p>
              <p dangerouslySetInnerHTML={{ __html: data.description.paragraph2 }}></p>
              <p dangerouslySetInnerHTML={{ __html: data.description.paragraph3 }}></p>
            </div>
            
            <div className="highlights-section">
              <h4>Our Identity</h4>
              <div className="highlights-grid">
                {data.highlights.map((highlight, index) => (
                  <div key={index} className="highlight-card">
                    <i className={highlight.icon}></i>
                    <span dangerouslySetInnerHTML={{ __html: highlight.text }}></span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="about-visual">
            <div className="image-card">
              <img 
                src={data.image.src} 
                alt={data.image.alt}
                className="about-image"
              />
              <div className="image-overlay">
                <h4>{data.image.overlayTitle}</h4>
                <p>{data.image.overlayDescription}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-wine">
        <div className="wine-bubble bubble-1"></div>
        <div className="wine-bubble bubble-2"></div>
        <div className="wine-bubble bubble-3"></div>
        <div className="wine-bubble bubble-4"></div>
      </div>
    </section>
  );
};

export default About;